import React from "react";
import { Link } from "react-router-dom";
import "../css/header.css";
import { FaShoppingCart } from "react-icons/fa";

const Header = () => {
  const handleCartClick = () => {
    console.log("Cart clicked");
  };

  return (
    <header className="header">
      <div className="header-left">
        <img src="/hh logo.jpeg" alt="Logo" />
      </div>

      <div className="header-right">
        <ul className="header-links">
          <li><Link to="/">Home</Link></li>
          <li><Link to="#">Blog</Link></li>
          <li><a href="#pro">Product</a></li> {/* Navigate to Home/Products */}
          <li><Link to="#">Contact Us</Link></li>
        </ul>

        <button className="cart-icon-btn" onClick={handleCartClick}>
          <FaShoppingCart className="cart-icon" />
          <span className="cart-badge">0</span>
        </button>
      </div>
    </header>
  );
};

export default Header;
